module.exports = __webpack_public_path__ + "d478762a6080de36554c78ecccdd528d.svg";